import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductGallery = (context) => {
  if (!context || !context.closest('.product-template')) return;
  const template = context.closest('.product-template');
  const slider = context.querySelector('.product-gallery__slider');

  const swiper = new Swiper(slider, {
    loop: false,
    slidesPerView: 'auto',
    freeMode: true,
    scrollbar: {
      el: slider.querySelector('.product-gallery__scrollbar'),
    },
    navigation: {
      prevEl: slider.querySelector('.product-gallery__arrow--left'),
      nextEl: slider.querySelector('.product-gallery__arrow--right'),
    },
  });

  const pswpElement = document.querySelector('.pswp');
  if (pswpElement) {
    slider
      .querySelectorAll('.product-gallery__media img')
      .forEach((image, index) =>
        image.addEventListener('click', () => {
          if (window.PREVENT_ZOOM) return;
          const zoomImages = Array.from(
            slider.querySelectorAll(
              '.product-gallery__media:not([data-image-id]) img[data-aspectratio][data-zoom-src], .product-gallery__media--active img[data-aspectratio][data-zoom-src]',
            ),
          );
          const items = zoomImages.map((el) => {
            const aspectRatio = parseFloat(el.getAttribute('data-aspectratio'));
            const zoomImg = el.getAttribute('data-zoom-src');
            return {
              src: zoomImg,
              w: 2000 * aspectRatio,
              h: 2000,
            };
          });
          const clickedIndex = zoomImages.findIndex(
            (el) => el.src === image.src,
          );

          const gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            {
              index: clickedIndex >= 0 ? clickedIndex : 0,
              zoomEl: false,
              shareEl: false,
              fullscreenEl: false,
              arrowKeys: false,
              counterEl: true,
              showHideOpacity: true,
              preloaderEl: false,
              tapToToggleControls: false,
            },
          );
          gallery.init();
        }),
      );

    template
      .querySelectorAll('.product-single .product__image[data-image-id]')
      .forEach((mainImg) => {
        const galleryImg = slider.querySelector(
          `[data-image-id="${mainImg.dataset.imageId}"] img[data-zoom-src]`,
        );
        if (galleryImg) {
          mainImg.addEventListener('click', () => {
            galleryImg.click();
          });
        }
      });
  }

  $(template).on('variantChange', (e) => {
    if (!e.variant) return;

    if (e.variant.featured_image) {
      const newImage = slider.querySelector(
        `[data-image-id="${e.variant.featured_image.id}"]`,
      );
      const activeImage = slider.querySelector(
        '.product-gallery__media--active',
      );
      const defaultImage = slider.querySelector('[data-image-id="default"]');
      if (activeImage && (newImage || defaultImage)) {
        activeImage.classList.remove('product-gallery__media--active');
      }
      if (newImage) {
        newImage.classList.add('product-gallery__media--active');
      } else if (defaultImage) {
        defaultImage.classList.add('product-gallery__media--active');
      }
      swiper.slideTo(0);
    }
  });
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.product-template .product-gallery__container'),
    (el) => {
      window.dAgency.initProductGallery(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll(
        '.product-template .product-gallery__container',
      ),
      (el) => {
        window.dAgency.initProductGallery(el);
      },
    );
  });
}
